import { RootState } from '@reducers';

export const selectPassword = (state: RootState) => state.userDashboardRouteReducer.passwordReducer;
